import { useState } from "react";
import { Hexagon, Mail, Github, Twitter, Linkedin } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { SupportModal } from "@/components/SupportModal";

const COLS = [
  { title: "Product", links: ["Services", "Digital Twin", "AI Workflow", "Pricing"], ids: ["services", "digital-twin", "ai-workflow", "pricing"] },
  { title: "Company", links: ["Teams", "Partnership", "Diversity & Inclusion", "Engagements"], ids: ["teams", "partnership", "diversity", "engagements"] },
  { title: "Resources", links: ["Docs", "Resources", "API Reference", "Terms & Policy"], ids: ["docs", "docs", "docs", "terms"] },
];

export const Footer = () => {
  const navigate = useNavigate();
  const [support, setSupport] = useState(false);

  const handle = (id) => {
    if (id === "terms") { navigate("/terms"); return; }
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-slate-950 border-t border-slate-800/80 pt-16 pb-10 px-4 sm:px-6 lg:px-8" id="resources">
      <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2">
          <div className="flex items-center gap-2.5 mb-4">
            <Hexagon className="w-7 h-7 text-emerald-400" strokeWidth={2.2} />
            <span className="font-display text-xl font-bold text-white">Wiwi</span>
          </div>
          <p className="text-sm text-slate-500 max-w-xs leading-relaxed">
            The intelligent Digital Twin Engine for game backend development — architect, build and optimize game systems 100x faster.
          </p>
          <button onClick={() => setSupport(true)} data-testid="footer-support-btn"
            className="mt-5 inline-flex items-center gap-2 text-sm text-emerald-400 hover:text-emerald-300 transition-colors">
            <Mail className="w-4 h-4" /> 24/7 Technical Support
          </button>
          <p className="mt-2 text-xs font-mono text-slate-600">kaadeconstruction@gmail.com</p>
        </div>
        {COLS.map((c) => (
          <div key={c.title}>
            <h4 className="text-xs font-mono uppercase tracking-widest text-slate-500 mb-4">{c.title}</h4>
            <ul className="space-y-2.5">
              {c.links.map((l, i) => (
                <li key={l + i}>
                  <button onClick={() => handle(c.ids[i])} data-testid={`footer-link-${c.ids[i]}-${i}`}
                    className="text-sm text-slate-400 hover:text-emerald-400 transition-colors">{l}</button>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="max-w-7xl mx-auto mt-12 pt-6 border-t border-slate-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-slate-600">© {new Date().getFullYear()} Wiwi Digital Twin Engine. All rights reserved.</p>
        <div className="flex items-center gap-4 text-slate-500">
          <Github className="w-4 h-4 hover:text-emerald-400 cursor-pointer transition-colors" />
          <Twitter className="w-4 h-4 hover:text-emerald-400 cursor-pointer transition-colors" />
          <Linkedin className="w-4 h-4 hover:text-emerald-400 cursor-pointer transition-colors" />
        </div>
      </div>
      <SupportModal open={support} onClose={() => setSupport(false)} />
    </footer>
  );
};
